import React from 'react'
import './Home.css'





const Home = () => {
  return (

        <div className='homepage'>
          <p>
              Sofia Mäkiniemi is a multifaceted Swedish artist currently based in
              Stockholm, Sweden. With a diverse background that spans music, art history, and curation, Mäkiniemi’s artistic journey is a testament to the
              richness that interdisciplinary exploration can bring to
              the creative process.
          </p>
          <p>
              Mäkiniemi is immersed in an exploration of autobiographical art, with a particular emphasis on themes of
              grief and trauma, but also mental health and neurodivergency. This introspective journey is carried out through
              different kinds of photography and filmed documentation. Through her camera lens, she opens a dialogue
              about the shared human experiences of pain, loss, and
              resilience. The raw honesty embedded in her creations
              creates a bridge between artist and audience, fostering
              a connection that transcends the confines of the gallery
              space.
          </p>
          <p>
              Through the usage of humour and constatly challenging
              what is acceptable to show Mäkiniemi likes to make the
              audience feel a little uncomfortable. By baring intimate
              situation and then exposing the viewer to this she wants
              them to reflect over their own imperfections and what
              their perception of the everyday is.
          </p>
            
        </div>

  )
}

export default Home